var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableExchangeButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.727,
    height: 16.727,
    viewBox: "0 0 16.727 16.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Password",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M11.18,0H4.045A3.922,3.922,0,0,0,0,4.252v6.723a3.918,3.918,0,0,0,4.045,4.252H11.18a3.919,3.919,0,0,0,4.047-4.252V4.252A3.919,3.919,0,0,0,11.18,0Z",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.47 -0.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "swap",
    d: "M3.544,6.718h7.068l-.87.652a.544.544,0,1,0,.652.87l2.175-1.631a.544.544,0,0,0,0-.864l-2.1-1.631a.544.544,0,0,0-.669.859l.854.658H3.544a.544.544,0,1,0,0,1.087Zm8.7,3.806H5.175l.87-.652A.544.544,0,0,0,5.392,9L3.217,10.632a.544.544,0,0,0,0,.864l2.1,1.631a.544.544,0,0,0,.669-.859l-.854-.658h7.111a.544.544,0,0,0,0-1.087Z",
    fill: "#199b8b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableExchangeButtonIcon);
export default __webpack_public_path__ + "static/media/table-exchange-button-icon.2be3419e71d39982269dc066db9f4f95.svg";
export { ForwardRef as ReactComponent };